export const reloadWithoutCache = () => {
  const q = new URLSearchParams(window.location.search)
  q.set('cachebuster', `${Date.now()}`)
  window.location.href = `${window.location.origin}${window.location.pathname}?${q}${window.location.hash}`
}
